class Timer {
    constructor(callback, timeout, intervalCallback, interval = 1000) {
        this.callback = callback;
        this.timeout = timeout;
        this.intervalCallback = intervalCallback || (() => {});
        this.interval = interval;
    }

    runNextWait() {
        const wait = this.timeLeft - this.interval > 0 ? this.interval : this.timeLeft;

        return setTimeout(this.onInterval.bind(this, wait), wait);
    }

    onInterval(waited) {
        this.timeLeft -= waited;
        this.intervalCallback(this.timeLeft);
        if (this.timeLeft <= 0) {
            this.callback();

            return;
        }

        this.timer = this.runNextWait();
    }

    stop() {
        clearTimeout(this.timer);
    }

    start() {
        this.timeLeft = this.timeout;
        this.intervalCallback(this.timeLeft);
        this.timer = this.runNextWait();
    }
}
